import { Handle, Position } from "@xyflow/react";
import { BiMemoryCard, BiPlus } from "react-icons/bi";
import { BsRobot } from "react-icons/bs";
import { PiPlugsConnected } from "react-icons/pi";
import { TbSparkles } from "react-icons/tb";

const AgentNode = ({ data, setOpenOverDropdown }) => {
    const handleAdd = (e) => {
        e.stopPropagation();
        data.onAddNext?.(data.id);
    };
    return (
        <div className="default_node agent_node">

            <Handle
                type="source"
                position={Position.Right}
                className="custom-handle"
            />

            <Handle
                type="target"
                position={Position.Left}
                className="custom-handle"
            />

            <div className="custom_node_content">
                <div className="custom_node_title">
                    <i><TbSparkles /></i>
                    <span >
                        {data?.params?.custom_name || "Trigger"}
                    </span>
                </div>
                {data?.params?.plugin || data?.params?.memory && (
                    <div className="bottom_node">
                        {data?.params?.plugin && (
                            <i title="Plugin"><PiPlugsConnected /></i>
                        )}

                        {data?.params?.memory && (
                            <i title="Memory"><BiMemoryCard /></i>
                        )}
                    </div>
                )}
            </div>


            <div className="node_right_plus" onClick={handleAdd}>
                <BiPlus />
            </div>

        </div>
    );
};

export default AgentNode;